module.exports = __webpack_public_path__ + "media/1_10.7dca2cfe.wav";